import React from "react";
import { Backdrop, Button, createStyles, Fade, makeStyles, Modal, Theme, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        paper: {
            backgroundColor: theme.palette.background.paper,
            border: '2px solid #000',
            boxShadow: theme.shadows[5],
            padding: theme.spacing(2, 4, 3),
        },
        footerButtons: {
            marginTop: '20px',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-around',
        },
        yesButton: {
            color: 'white',
            backgroundColor: '#303844', 
            width: '150px',
        },
        noButton: {
            color: 'white',
            backgroundColor: '#869098', 
            width: '150px',
        },
    }),
);

type NotificationProps = {
    isOpen: boolean;
    questionText: string;
    okClick: () => void;
    close: () => void;
};

export const Notification = (props: NotificationProps) => {
    const classes = useStyles();
    const {isOpen, questionText, close, okClick} = props;

    return (
        <Modal
            className={classes.modal}
            open={isOpen}
            onClose={close}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={isOpen}>
                <div className={classes.paper}>
                    <Typography variant={"h6"}>
                        {questionText}
                    </Typography>
                    <div className={classes.footerButtons}>
                        <Button size="large" className={classes.noButton} onClick={okClick}>
                            OK
                        </Button>
                    </div>
                </div>
            </Fade>
        </Modal>
    )
    
}